import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LoginService } from './login.service';

@Component({
  selector: 'login',
  template: '', //No login page
  providers: [ LoginService ]
})
export class LogoutComponent{
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loginService:LoginService
  ){
    this.doLogout();
  }
  
  doLogout(){
    this.loginService.logout().then((res:any)=>{
      this.router.navigateByUrl('/');
    }).catch((e)=>{
      this.router.navigateByUrl('/error/not-authorised');
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/login/logout.component.ts